<div class="container">
    <div class="split-example form-container" >
        <as-split (dragEnd)="onResize()"  direction="horizontal" restrictMove="true" [useTransition]="true">
            <as-split-area size="50">
                <as-split (dragEnd)="onResize()" direction="vertical" restrictMove="true">
                    <as-split-area>
                        <div class="form-container-ignore">
                            <sprout-forms *ngIf="form" [model]="form" (formValue)="onFormValueChange($event, this)"></sprout-forms>
<!--                            <div *ngIf="!form" ><mat-spinner></mat-spinner> Loading...please wait...</div>-->
                            <div *ngIf="!form" class="alert alert-info">Loading...please wait...</div>
                        </div>
                    </as-split-area>
                    <as-split-area style="position: relative;">
                        <div *ngIf="modelInitialized && modelView == 'null'" class="alert alert-info">
                            Please start completing the above form to view the form model.
                        </div>
                        <div *ngIf="modelInitialized && modelView !== 'null'">
                            <!--                        <button mat-mini-fab color="accent" (click)="onTranslate()" aria-label="Options" class="md-fab-bottom-right">-->
                            <!--                            <mat-icon>translate</mat-icon>-->
                            <!--                        </button>-->
                            <button mat-mini-fab color="accent" [matMenuTriggerFor]="menu" aria-label="Options" class="md-fab-bottom-right">
                                <!--                            <mat-icon>translate</mat-icon>-->
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="onExportTranslations()">
                                    <mat-icon>get_app</mat-icon>
                                    <span>Export Translations</span>
                                </button>
                                <button mat-menu-item (click)="onImportTranslations()">
                                    <mat-icon>publish</mat-icon>
                                    <span>Import Translations</span>
                                </button>
                            </mat-menu>
                            <ngx-monaco-editor class="process-builder-editor" [options]="monacoJsonOptions" [(ngModel)]="modelView"></ngx-monaco-editor>
                        </div>
                        <div *ngIf="!modelInitialized" class="alert alert-info">
                            Initializing...please wait...
                        </div>
                    </as-split-area>
                </as-split>
            </as-split-area>
            <as-split-area size="50">
                <as-split (dragEnd)="onResize()" direction="vertical" restrictMove="true">
                    <as-split-area size="50">
                        <div *ngIf="templateInitialized">
                            <ngx-monaco-editor #handlebarsEditor (onInit)="onInitHandlebarsEditor($event, context)" class="process-builder-editor" [options]="monacoHandlebarsOptions" [(ngModel)]="template"></ngx-monaco-editor>
                        </div>
                        <div *ngIf="!templateInitialized" class="alert alert-info">
                            Initializing...please wait...
                        </div>
                    </as-split-area>
                    <as-split-area size="50">
                        <div *ngIf="htmlInitialized">
                            <div *ngIf="html" [innerHTML]="html | safeHtml" class="html-output"></div>
                            <div *ngIf="!html" class="alert alert-info">Please create a template above, in order to view output.</div>
                        </div>
                        <div *ngIf="!htmlInitialized" class="alert alert-info">
                            Initializing...please wait...
                        </div>
                    </as-split-area>
                </as-split>
            </as-split-area>
        </as-split>
    </div>
</div>

<sprout-form-upload [hidden]="true" (fileImportTOEventEmitter)="setFileImportTO($event)" [form]="form"></sprout-form-upload>
